const link = {
  home:
    'https://mbas.mbs.boc.cn/WeiBankFront/weixinVue/servicePlatformWX/indexWX.html#/coupons?state=1&dev=weixin&appid=wx567af860fd4db040&codeInfo=1BB57FB929AAD94D6F0FBB00FF0A3BEE',
  dmaster: 'https://uber_debitmc_boc.d-enjoy.com.cn/#/index',
  dvisa:
    'https://visaoffer.yijiuplus.com/index/signup?utm_source=WeChat&referenceId=d29ba87bedc72f58b0736171c3ebca80',
  master: 'https://www.mcomp.com.cn/bocDebit/showOfferH5Guide/',
  visa:
    'https://studyabroad.visa-campaign.com/banks/interest.php?bank=boc_debit#student-us-preparation',
  visa2:
    'https://visaoffer.yijiuplus.com/index/index/index?cid=31&bankid=boc_debit'
};

export default link;
